var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6.25h24c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0128 25.75H4A1.75 1.75 0 012.25 24V8c0-.966.784-1.75 1.75-1.75z",
    fill: "#fff",
    stroke: "#D1D1D1",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.178 12.07h-4.375v7.861h4.375V12.07z",
    fill: "#FF5F00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.08 16a4.99 4.99 0 011.91-3.931 5 5 0 100 7.862A4.992 4.992 0 0114.08 16z",
    fill: "#EB001B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 16a4.999 4.999 0 01-8.09 3.931 5 5 0 000-7.862A5 5 0 0124.08 16z",
    fill: "#F59600"
  })));
}

export default SvgIconCreditCardMasterCard;